import type { FC } from "react";

import { Button } from "@jti/core-components/components/Button";

import styles from "./QuizExitConfirmation.module.scss";

export type QuizExitConfirmationProps = {
  title: string;
  description: string;
  dropQuizLabel: string;
  stayLabel: string;
  onDropQuiz: () => void;
  onStay: () => void;
};

export const QuizExitConfirmation: FC<QuizExitConfirmationProps> = ({
  title,
  description,
  dropQuizLabel,
  stayLabel,
  onDropQuiz,
  onStay,
}) => (
  <div className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
    <p className={styles.description}>{description}</p>
    <div className={styles.ctasMobile}>
      <Button variant="secondary" size="sm" onClick={onDropQuiz}>
        {dropQuizLabel}
      </Button>
      <Button variant="primary" size="sm" onClick={onStay}>
        {stayLabel}
      </Button>
    </div>
    <div className={styles.ctasDesktop}>
      <Button variant="secondary" size="lg" onClick={onDropQuiz}>
        {dropQuizLabel}
      </Button>
      <Button variant="primary" size="lg" onClick={onStay}>
        {stayLabel}
      </Button>
    </div>
  </div>
);
